import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, FormControlLabel, Checkbox, Grid } from '@mui/material';

const AddLocalUserDialog = ({ open, onClose, onSubmit, dashboard }) => {
    const [username, setUsername] = useState('');
    const [nome_cognome, setFullName] = useState('');
    const [password, setPassword] = useState('');
    const [checkboxes, setCheckboxes] = useState(Array(dashboard.length).fill(false));

    React.useEffect(() => {
        setUsername('');
        setFullName('');
        setPassword('');
        setCheckboxes(Array(dashboard.length).fill(false));
    }, [open, dashboard.length]);

    const handleCheckboxChange = (index) => {
        const newCheckboxes = [...checkboxes];
        newCheckboxes[index] = !newCheckboxes[index];
        setCheckboxes(newCheckboxes);
    };

    const handleSubmit = () => {
        onSubmit({ username, nome_cognome, password, checkboxes });
        onClose();
    };

    const isValid = username.trim() !== '' && password.length >= 8;

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Nuovo utente locale</DialogTitle>
            <DialogContent>
                <Grid container spacing={2} sx={{ minWidth: '350px', pt: 1 }}>
                    <Grid item xs={12}>
                        <TextField
                            autoFocus
                            margin="dense"
                            label="Username"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            label="Nome e Cognome"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={nome_cognome}
                            onChange={(e) => setFullName(e.target.value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            margin="dense"
                            label="Password (min 8 caratteri)"
                            type="password"
                            fullWidth
                            variant="outlined"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </Grid>
                </Grid>
                <div>
                    <h3>Seleziona le dashboard a cui dare accesso:</h3>
                    <Grid container spacing={2}>
                        {checkboxes.map((checked, index) => (
                            <Grid item xs={6} sm={4} key={index}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={checked}
                                            onChange={() => handleCheckboxChange(index)}
                                        />
                                    }
                                    label={dashboard[index]}
                                />
                            </Grid>
                        ))}
                    </Grid>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleSubmit} color="primary" disabled={!isValid}>
                    OK
                </Button>
                <Button onClick={onClose} color="secondary">
                    Annulla
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddLocalUserDialog;
